import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Reveal } from '../components/Reveal';
import { Link } from 'react-router-dom';
import { ATMOSPHERE } from '../data/products';
import AtmoBg from '../components/AtmoBg';

const VALUES = ['Timeless', 'Premium', 'Minimal', 'Precise', 'Intelligent', 'Sustainable', 'Product-first', 'Hospitality-inspired'];

export default function About() {
  return (
    <main data-testid="about-page" className="bg-white text-[#111]">
      <Helmet>
        <title>About MODULAROOM</title>
        <meta name="description" content="MODULAROOM designs and manufactures luxury modular homes and capsule suites in India, blending intelligent design, sustainable materials and precision engineering for a global clientele." />
        <link rel="canonical" href="https://modularoom.com/about" />
      </Helmet>
      <section className="relative overflow-hidden pt-40 md:pt-52 pb-24">
        <AtmoBg src={ATMOSPHERE.aboutHeadline} base="white" opacity={0.09} />
        <div className="relative max-w-[1440px] mx-auto px-6 md:px-12 grid grid-cols-1 md:grid-cols-12 gap-10 items-start">
        <div className="md:col-span-4 text-[11px] tracking-[0.32em] uppercase text-black/50">Brand Philosophy</div>
        <div className="md:col-span-8">
          <Reveal>
            <h1 className="font-display text-5xl md:text-6xl lg:text-7xl leading-[1.02] tracking-tight">
              Engineered like a product.<br/>
              <span className="text-black/40">Crafted for modern living.</span>
            </h1>
          </Reveal>
          <Reveal delay={0.15} className="mt-8 max-w-2xl text-lg text-black/70 leading-relaxed">
            MODULAROOM crafts premium luxury modular homes that blend intelligent design, sustainable materials and modern technology. Every capsule suite and studio suite is engineered as a complete architectural product, designed with precision, built in a factory and delivered as a signature.
          </Reveal>
        </div>
        </div>
      </section>

      <section className="relative overflow-hidden bg-[#F5F5F5] py-28 md:py-40">
        <AtmoBg src={ATMOSPHERE.aboutValues} base="gray" opacity={0.08} />
        <div className="relative max-w-[1440px] mx-auto px-6 md:px-12">
          <div className="text-[11px] tracking-[0.32em] uppercase text-black/50">Values</div>
          <div className="mt-10 grid grid-cols-2 md:grid-cols-4 gap-y-10 gap-x-6 border-t border-black/10 pt-10">
            {VALUES.map((v) => (
              <div key={v} className="font-display text-2xl md:text-3xl tracking-tight">{v}.</div>
            ))}
          </div>
        </div>
      </section>

      <section className="bg-[#111] text-white py-28 md:py-40">
        <div className="max-w-[1440px] mx-auto px-6 md:px-12 grid grid-cols-1 md:grid-cols-12 gap-10 items-end">
          <div className="md:col-span-8">
            <div className="text-[11px] tracking-[0.32em] uppercase text-[#C7A36A]">Made in India · Delivered worldwide</div>
            <h2 className="font-display text-4xl md:text-6xl mt-4 tracking-tight leading-[1.02]">
              Proudly manufactured in India with world-class precision.
            </h2>
          </div>
          <div className="md:col-span-4 md:text-right">
            <Link to="/contact#book" className="inline-flex items-center gap-2 rounded-full bg-white text-[#111] px-8 py-4 text-[13px] tracking-[0.2em] uppercase hover:bg-[#C7A36A] hover:text-white transition-colors">
              Book Consultation
            </Link>
          </div>
        </div>
      </section>
    </main>
  );
}
